import { createReducer, Action, on } from '@ngrx/store';
import { State, initialState } from './state';
import * as actions from './actions';

const reducer = createReducer(
  initialState,
  on(actions.load, (state => {
    return {
      ...state,
      loading: true
    };
  })),
  on(actions.loadSuccess, ((state, { tradeFeed })  => {
    return {
      ...state,
      loading: false,
      data: tradeFeed
    };
  })),
  on(actions.clear, ((state)  => {
    return initialState;
  })),
  on(actions.addComment, ((state)  => {
    return {
      ...state,
      loading: true
    };
  }))
);

export function feedReducer(state: State, action: Action) {
  return reducer(state, action);
}
